<script setup lang="ts">
defineProps<{
  severity: string;
  postfix?: string;
}>();

const severityColors: Record<string, { outer: string; inner: string }> = {
  high: { outer: 'tw:bg-vuln-high-light', inner: 'tw:bg-vuln-high' },
  medium: { outer: 'tw:bg-vuln-medium-light', inner: 'tw:bg-vuln-medium' },
  low: { outer: 'tw:bg-vuln-low/20', inner: 'tw:bg-vuln-low' },
  primary: { outer: 'tw:bg-[#FDC7C0]', inner: 'tw:bg-[#FB7462]' },
  secondary: { outer: 'tw:bg-[#FFE1C6]', inner: 'tw:bg-[#FF7A08]' },
  supporting: { outer: 'tw:bg-[#DFEBFF]', inner: 'tw:bg-[#3180F6]' },
};

function getSeverityColors(severity: string) {
  return severityColors[severity] ?? severityColors.high;
}
</script>

<template>
  <div class="tw:flex tw:gap-1.5 tw:items-center">
    <div class="tw:relative tw:size-4 tw:rounded-full" :class="getSeverityColors(severity).outer">
      <span
        class="tw:absolute tw:top-1/2 tw:left-1/2 tw:-translate-x-1/2 tw:-translate-y-1/2 tw:size-2 tw:rounded-full"
        :class="getSeverityColors(severity).inner"
      ></span>
    </div>
    <div class="tw:typography-small tw:text-secondary">
      <span class="tw:capitalize"> {{ severity }} </span>{{ postfix ? ` ${postfix}` : '' }}
    </div>
  </div>
</template>
